import { createActions } from 'redux-actions'
import { ACTION_PREFIX } from './consts'

export const {
  init: { request: init, success: initSuccess, failure: initFailure },
  setActive,
  setPermissions,
  clearEntries,
  loadEntries: {
    setCondition,
    request: loadEntries,
    success: loadEntriesSuccess,
    failure: loadEntriesFailure,
  },
  loadEntry: {
    request: loadEntry,
    success: loadEntrySuccess,
    failure: loadEntryFailure,
  },
  addEntry: {
    request: addEntry,
    success: addEntrySuccess,
    failure: addEntryFailure,
  },
  removeEntry: {
    request: removeEntry,
    success: removeEntrySuccess,
    failure: removeEntryFailure,
  },
  cloneEntry: {
    request: cloneEntry,
    success: cloneEntrySuccess,
    failure: cloneEntryFailure,
  },
  updateEntry: {
    request: updateEntry,
    success: updateEntrySuccess,
    failure: updateEntryFailure,
  },
  updateForm: { submit: submitUpdateForm },
  createForm: { submit: submitCreateForm },
} = createActions(
  {
    INIT: {
      REQUEST: () => ({}),
      SUCCESS: () => ({}),
      FAILURE: (error) => ({ error }),
    },
    SET_ACTIVE: (id) => ({ id }),
    SET_PERMISSIONS: (permissions) => ({ permissions }),
    CLEAR_ENTRIES: () => ({}),
    LOAD_ENTRIES: {
      REQUEST: () => ({}),
      SUCCESS: (entries, total) => ({ entries, total }),
      FAILURE: (error) => ({ error }),
    },
    LOAD_ENTRY: {
      REQUEST: (id) => ({ id }),
      SUCCESS: (data) => ({ data }),
      FAILURE: (error) => ({ error }),
    },
    ADD_ENTRY: {
      REQUEST: (data) => ({ data }),
      SUCCESS: (entry) => ({ registratedEntry: entry }),
      FAILURE: (error) => ({ error }),
    },
    UPDATE_ENTRY: {
      REQUEST: (data) => ({ data }),
      SUCCESS: (entry) => ({ updated: entry }),
      FAILURE: (error) => ({ error }),
    },
    CLONE_ENTRY: {
      REQUEST: (source, copyBoard, suffix) => ({ source, copyBoard, suffix }),
      SUCCESS: (entry) => ({ clonedEntry: entry }),
      FAILURE: (error) => ({ error }),
    },
    REMOVE_ENTRY: {
      REQUEST: (id, password) => ({ id, password }),
      SUCCESS: (entry) => ({ removedEntry: entry }),
      FAILURE: (error) => ({ error }),
    },
    CREATE_FORM: {
      SUBMIT: (data, dispatch, props) => ({ data, dispatch, props }),
    },
    UPDATE_FORM: {
      SUBMIT: (data, dispatch, props) => ({ data, dispatch, props }),
    },
  },
  {
    prefix: ACTION_PREFIX,
  },
)
